import React from 'react';
import { Modal, message, Space, Table } from 'antd';
import { QrcodeOutlined } from '@ant-design/icons';
import { openMiniPage } from '../../utils/open-mini-page';
import { getCurrentShopId } from '../shop/get-current-shop';

const pageMap = {
    index: "/pages/index/index",
    goodsDetail: "/pages/goods-detail/index",
    goodsList: "/pages/goods-list/index",
    couponList: "/pages/coupon-list/index",
    couponDetail: "/pages/coupon-tmp-detail/index",
    custom: "/pages/operation/index",
}

export default () => {

    const [dataSource, setDataSource] = React.useState([]);
    const columns = [
        {
            title: '名称',
            dataIndex: 'title',
        },
        {
            title: '操作',
            dataIndex: 'code',
            render: (code, record) => {
                return (
                    <Space>
                        <a href={`/mall/page/edit?pageId=${record.pageId || ''}`}>装修</a>
                        {code && <a onClick={() => openPage(code, record.shopId, record.pageId)}>查看</a>}
                        {record?.code === 'custom' && <a onClick={() => viewQRcode(record.pageId)}><QrcodeOutlined /></a>}
                    </Space>
                )
            }
        },
    ];

    const viewQRcode = async (pageId) => {
        const shopId = await getCurrentShopId();
        const res = await fetch(`/api/shop/get-page-qrcode?pageId=${pageId}&shopId=${shopId}`);
        const result = await res.json();
        if (result && result.success) {
            Modal.info({
                icon: null,
                title: '客户分享二维码',
                content: <div style={{textAlign: 'center'}}><img src={`https://img.yxdj.tech/${result.data.url}`} style={{width: 200}} /></div>,
            });
        }
    }

    const getPageList = async () => {
        
        const response = await fetch('/api/page/list');
        const result = await response.json();
        const rows = result?.data?.rows || [];

        if (result?.success) {
            setDataSource(rows);
        } else {
            message.error(result.data);
        }
    }

    const openPage = async (code, shopId, pageId) => {
        const accId = window.__baseInfo?.accId;
        const path = pageMap[code];
        if (!path) {
            message.error('页面不存在');
            return;
        }
        await openMiniPage(accId, path, { pageId, shopId });
    }

    React.useEffect(() => {
        getPageList();
    }, [])
    
    return (
        <div>
            <Table rowKey='pageId' columns={columns} dataSource={dataSource} />
        </div>
    )
};